<template>
  <div class="portlet light">
    <div class="row">
      <div class="col-xs-12 col-md-4 col-md-offset-4">
        <div style="border: 1px solid #C2CAD8; margin-right: 1em; padding: 1em; margin-bottom: 1em;">
          <div class="ss-titre text-center">
            <strong>Logo</strong>&nbsp;-&nbsp;<em class="text-center" style="font-size: 11px;">jpg ou png acceptés uniquement</em>
          </div>
          <v-image-upload
            name="officeIcon"
            @image="addImage"
            @validated="send"
            :oldImage="oldImage">
          </v-image-upload>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'OfficeLogoForm',
  props: {
    office: {
      type: Object,
      default: () => {
        return {}
      }
    },
    oldImage: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      image: new vImageHelper()
    }
  },
  methods: {
    addImage(event) {
      this.image.add(event)
    },
    send() {
      try {
        this.image.send(`/office/${this.office.id}/image/officeIcon`)
      }
      catch(e) {
        console.log(e)
      }
    }
  }
};
</script>

<style lang="css" scoped>
</style>
